export default "__VITE_ASSET__CDx7O$yB__"